import styled from 'styled-components'
import { orange, blue, gold, blackGreen, textMuted, white, grey } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { text, leading } from '@/theme/typography'

// Deterministic avatar backgrounds — the backend does not store a per-user
// colour, so we cycle a fixed brand palette by position. Shared so other bento
// surfaces (e.g. the money tile's balance lines) colour avatars identically.
const PALETTE = [orange, gold, blue, blackGreen]
export const avatarColorForIndex = (index: number): string => PALETTE[index % PALETTE.length]

export const StackRoot = styled.button<{ $gap: number; $interactive: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: ${({ $gap }) => $gap}px;
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	color: inherit;
	cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};

	&:focus-visible {
		outline: 2px solid ${textMuted};
		outline-offset: 3px;
		border-radius: ${radii.tiny};
	}
`

export const AvatarRow = styled.span`
	display: inline-flex;
`

export const AvatarCircle = styled.span<{ $size: number; $index: number; $bg: string }>`
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	border-radius: ${radii.round};
	border: 2px solid ${white};
	background: ${({ $bg }) => $bg};
	color: ${white};
	${text.labelSm}
	font-size: ${({ $size }) => Math.round($size * 0.4)}px;
	line-height: ${leading.none};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	flex-shrink: 0;
	margin-left: ${({ $index, $size }) => ($index ? -Math.round($size * 0.3) : 0)}px;
`

export const AvatarImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
`

export const MoreBubble = styled(AvatarCircle)`
	background: ${grey};
	color: ${textMuted};
`

export const MembersCaption = styled.span`
	${text.bodyXs}
	color: ${textMuted};
	white-space: nowrap;
`
